import modules_statements from './statements/index.js'
import modules_regulars from './regulars/index.js'
import modules_payments from './payments/index.js'
import modules_paymentItems from './paymentItems/index.js'
import modules_pay from './pay/index.js'
import modules_osv from './osv/index.js'
import modules_invoices from './invoices/index.js'
import modules_certificates from './certificates/index.js'
import _actions_active_tab from './_actions/active_tab.js'
import _mutations_set_tab from './_mutations/set_tab.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        set_tab: _mutations_set_tab,
    },
    actions:{
        active_tab: _actions_active_tab,
    },
    modules:{
        certificates: modules_certificates,
        invoices: modules_invoices,
        osv: modules_osv,
        pay: modules_pay,
        paymentItems: modules_paymentItems,
        payments: modules_payments,
        regulars: modules_regulars,
        statements: modules_statements,
    },
}